import createReducer from 'legacy/src/shared/util/createReducer';
import { SET_ACTIVE_GROUP, SET_ACTIVE_STATUS, RESET_FILTERS } from './actions';

const initialState = {
  activeGroup: null,
  activeStatus: null,
};

const reducer = createReducer(initialState, {
  [SET_ACTIVE_GROUP]: (state, { payload }) => ({
    ...state,
    activeGroup: payload.id || null,
  }),
  [SET_ACTIVE_STATUS]: (state, { payload }) => ({
    ...state,
    activeStatus: payload.status || null,
  }),
  [RESET_FILTERS]: () => initialState,
});

export default reducer;
